const A6ResponseApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/response/cusres/get`,
    POST: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/response/cusres`
  };
  
  export default A6ResponseApiUrls;
  